import { graphql, type ResultOf } from "@/data-access/graphql";
import {
  MeFeedLastLocationFragment,
  MeTenantFragment,
  MeUserFragment,
} from "@/data-access/user/fragments/me-fragments";

export const MeQuery = graphql(
  `
    query Me {
      me {
        ...MeUserFragment
        defaultTenant {
          ...MeTenantFragment
        }
        tenants {
          ...MeTenantFragment
        }
      }
    }
  `,
  [MeUserFragment, MeFeedLastLocationFragment, MeTenantFragment],
);

export const UpdateLastVisitedLocation = graphql(`
  mutation updateLastVisitedLocation($lastVisitedLocation: String!) {
    updateLastVisitedLocation(lastVisitedLocation: $lastVisitedLocation) {
      id
      lastVisitedLocation
    }
  }
`);

export const UpdateFeedLastLocation = graphql(`
  mutation UpdateFeedLastLocation($input: UpdateFeedLastLocationInput!) {
    updateFeedLastLocation(input: $input) {
      feedId
      surface
      location
      updatedAt
    }
  }
`);

/** Same document as {@link UpdateLastVisitedLocation}, for keepalive `fetch`. */
export const updateLastVisitedLocationQueryString =
  UpdateLastVisitedLocation.loc?.source.body.trim() ?? "";

/** Same document as {@link UpdateFeedLastLocation}, for keepalive `fetch`. */
export const updateFeedLastLocationQueryString =
  UpdateFeedLastLocation.loc?.source.body.trim() ?? "";

export type MeQueryResult = ResultOf<typeof MeQuery>;
export type MeUser = MeQueryResult["me"];
export type MeTenant = MeUser["tenants"][number];
export type MeFeedLastLocation = MeUser["feedLastLocations"][number];
